import { Button, Modal, Table } from 'antd';
import { useEffect, useState } from 'react';

import { AuthorizedStateDto } from '@clh/api-client';
import { unwrapError, useApiClient } from '@clh/ui';

import { useToast } from '../hooks/use-toast';

export default function NurseStatePracticeAuthorizationsModal({
    nurseProfileId,
    onClose,
}: {
    nurseProfileId: string;
    onClose?: () => void;
}) {
    const api = useApiClient();
    const [open, setOpen] = useState(true);
    const [loading, setLoading] = useState(false);
    const [authorizedStates, setAuthorizedStates] =
        useState<AuthorizedStateDto[]>();

    const { notification } = useToast();
    const fetchAuditHistory = async () => {
        setLoading(true);
        try {
            const results =
                await api?.nurseStatePracticeAuthorizationControllerGetNurseStatePracticeAuthorizations(
                    {
                        nurseProfileId,
                    }
                );
            setAuthorizedStates(results);
        } catch (err) {
            notification.error({ message: unwrapError(err), duration: 3 });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        void fetchAuditHistory();
    }, [api]);

    return (
        <Modal
            title={`Authorized States`}
            loading={loading}
            width={'60%'}
            open={open}
            onCancel={() => setOpen(false)}
            onClose={() => setOpen(false)}
            afterClose={() => onClose && onClose()}
            footer={[
                <Button key="back" onClick={() => setOpen(false)}>
                    Close
                </Button>,
            ]}
        >
            <Table
                dataSource={authorizedStates}
                bordered
                columns={[
                    {
                        dataIndex: 'state',
                        title: 'State',
                    },
                    {
                        dataIndex: 'practiceCode',
                        title: 'Practice Code',
                    },
                ]}
            />
        </Modal>
    );
}
